import { datadogRum } from '@datadog/browser-rum';
import { useContext, useEffect } from 'react';
import TradeContext from '~/context/common/TradeContext';

export default function useSetTradeIncentiveDDContext() {
  const {
    trades: { isLoaded },
    selectedTrade
  } = useContext(TradeContext);
  const { maxTradeTaxSavings, tradeIncentive } = selectedTrade ?? {};
  const hasOnlyIncentive = Boolean(tradeIncentive && !maxTradeTaxSavings);
  const hasOnlyTaxSavings =
    Boolean(!tradeIncentive && maxTradeTaxSavings) && tradeIncentive != null;

  useEffect(() => {
    if (!isLoaded) return;

    const state = () => {
      switch (true) {
        case !selectedTrade:
          return 'NoTrade';
        case hasOnlyIncentive:
          return 'Incentive';
        case hasOnlyTaxSavings:
          return 'Savings';
        case Boolean(tradeIncentive && maxTradeTaxSavings):
          return 'Incentive&Savings';
        default:
          return 'None';
      }
    };

    datadogRum.setGlobalContextProperty('traceIncentiveStatus', state());
  }, [
    hasOnlyIncentive,
    hasOnlyTaxSavings,
    isLoaded,
    maxTradeTaxSavings,
    selectedTrade,
    tradeIncentive
  ]);
}
